import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { getCommentsByView as getCommentsByViewFromMonolith } from '~/monolith-api/guides/getCommentsByView';
import {
   CommentContext,
   CommentsByView,
   CommentsByViewOptions,
   CommentView,
} from '~/monolith-api/guides/types';

const getCommentsByViewSchema = z.object({
   context: z.custom(),
   contextid: z.number(),
   view: z.custom(),
   limit: z.number().optional(),
   offset: z.number().optional(),
});

export async function getCommentsByView(
   context: CommentContext,
   contextid: number,
   view: CommentView,
   { limit, offset, ...common }: CommentsByViewOptions = {}
) {
   return await getCommentsByViewFromMonolith(context, contextid, view, {
      ...common,
      limit,
      offset,
   });
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { context, contextid, view, limit, offset } = getCommentsByViewSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getCommentsByView(context, contextid, view, {
         apiClient: monolithClient,
         limit: limit,
         offset: offset,
      });
      res.status(200).json(result);
   },
});

export const getCommentsByViewFromClient = (
   context: CommentContext,
   contextid: number,
   view: CommentView,
   { limit, offset }: CommentsByViewOptions = {}
): Promise<CommentsByView> => {
   return bff()
      .post('/guides/getCommentsByView', { context, contextid, view, limit, offset })
      .then(response => response.data);
};
